var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-dialog',{attrs:{"max-width":"700px"},on:{"shown":_vm.focusSelect},model:{value:(_vm.punDialog),callback:function ($$v) {_vm.punDialog=$$v},expression:"punDialog"}},[_c('a-select-2',{ref:"select2",attrs:{"slot":"body","id":"powerUserNavigation","options":_vm.getMenuItemOptions,"settings":{
      theme: 'bootstrap',
      templateResult: _vm.renderResultOption,
      templateSelection: _vm.renderSelectionOption,
      placeholder: _vm.$t('Components.PowerNavigation.Placeholder')
    }},on:{"change":_vm.navigateToPage},slot:"body",model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }